/* eslint no-param-reassign: "error" */

export default [
  {
    id: 'start',
    clear: true,
    content: `
    Hi! You have an exciting week ahead! Depending on your answers, you are about to have a great week or see your time seriously compromised. Get ready to play !
 
    To begin with, are you a man or a woman ?
    `,
    choices: ['gender_man', 'gender_woman', 'gender_neutral'],
  },
  {
    id: 'gender_man',
    optionText: 'A man',
    enter(model) {
      model.character('me').setQuality('gender', 'man')
    },
    content: `
      Thanks ! [Continue](@lundi)
    `,
  },
  {
    id: 'gender_woman',
    optionText: 'A woman',
    enter(model) {
      model.character('me').setQuality('gender', 'woman')
    },
    content: `
      Thanks ! [Continue](@lundi)
    `,
  },
  {
    id: 'gender_neutral',
    optionText: "I'd rather not say",
    enter(model) {
      model.character('me').setQuality('gender', 'neutral')
    },
    content: `
      Thanks ! [Continue](@lundi)
    `,
  },
]
